import { render, staticRenderFns } from "./IncomeExpend.vue?vue&type=template&id=81e848ee&scoped=true"
import script from "./IncomeExpend.vue?vue&type=script&lang=js"
export * from "./IncomeExpend.vue?vue&type=script&lang=js"
import style0 from "./IncomeExpend.vue?vue&type=style&index=0&id=81e848ee&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81e848ee",
  null
  
)

export default component.exports